import { trigger, transition, group, style, query, animate } from '@angular/animations';

export const animation = trigger('anim', [
  transition('* => true', [
    group([style({ opacity: 0, transform: 'translate3d(0, -10px, 0)' }), query('.inner', style({ opacity: 0 }))]),
    animate(150, style({ opacity: 1, transform: 'translate3d(0,0,0)' })),
    query('.inner', animate('150ms ease-out', style({ opacity: 1 }))),
  ]),
  transition('* => false', [
    group([style({ opacity: 1, transform: 'translate3d(0,0,0)' }), query('.inner', style({ opacity: 1 }))]),
    query('.inner', animate('100ms ease-out', style({ opacity: 0 }))),
    animate('200ms ease-out', style({ opacity: 0, transform: 'translate3d(0,-30px,0)' })),
  ]),
]);
